import React from "react";
import { useState,useEffect } from "react";
import "./DeliveryInvoiceEdit.css";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import {FormControl, Select, MenuItem} from "@mui/material";
import {  SalesReasonDetails } from "../../types/types";
import { getUomLabel } from "../../components/dms_common/DmsUtils";
import { useLocation } from "react-router-dom";


const DeliveryInvoiceReasonSelection = (props:{otherUnitName?: string | undefined, validate:ValidateFunctionType,reasonObject:SalesReasonDetails, onChange:(data:SalesReasonDetails)=>void, actionElement:JSX.Element, disabledUoms:string[]})=>{
    const {caseUnitLabel,otherUnitLabel,packUnitLabel} = getUomLabel();
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
    const reasonArray:string[] = ConfigDictionary.salesReturnReasons ?? ["Expired", "Damaged", "Wrong Order", "Slow Moving", "Consumer Complaint"];
    const reasonMap:{[key:string]:string[]} = ConfigDictionary.salesReturnReasonsMap ?? {};
    const [caseQty,setCaseQty] = useState(props.reasonObject.caseQty ?? 0);
    const [pieceQty,setPieceQty] = useState(props.reasonObject.pieceQty ?? 0);
    const [otherQty,setOtherQty] = useState(props.reasonObject.otherQty ?? 0);
    const [reason,setReason] = useState(props.reasonObject.reason);
    const [saleCondition,setSaleCondition] = useState(props.reasonObject.saleCondition);

    useEffect(()=>{

      setCaseQty(props.reasonObject.caseQty);
      setPieceQty(props.reasonObject.pieceQty);
      setOtherQty(props.reasonObject.otherQty);
      setReason(props.reasonObject.reason);
      setSaleCondition(props.reasonObject.saleCondition);
    },[props.reasonObject])
  
    useEffect(()=>{

        props.onChange({
          caseQty:caseQty,
          pieceQty:pieceQty,
          otherQty:otherQty,
          reason:reason,
          saleCondition:saleCondition
        })
  
    },[reason,caseQty,pieceQty,otherQty,saleCondition])

    const handleSaleConditionChange = (key:string)=>{

      setSaleCondition(key);
      setReason("");
    }
    
    return Object.keys(reasonMap).length == 0 ?
      (<div className="delivery-label-input-container-edit">
        <div className="cs-pc-container-edit">
          {caseUnitLabel && <CustomCsPcInput
            value={caseQty}
            onChange={(e) => {
                const qty:number = convertStringToNumber(e.target.value);
                props.validate(qty,caseQty,"caseQty");
                setCaseQty(qty);
              }
            }
            label="Cs"
            percentage={100}
          />}
          {otherUnitLabel && <CustomCsPcInput
            value={otherQty}
            onChange={(e) => {
              const qty:number = convertStringToNumber(e.target.value);
              props.validate(qty,otherQty,"otherQty");
              setOtherQty(qty);
            }}
            disabled={props.disabledUoms && props.disabledUoms.includes("otherQty")}
            label= {props.otherUnitName? props.otherUnitName: "Other"}
            percentage={100}
          />}
          {packUnitLabel && <CustomCsPcInput
            value={pieceQty}
            onChange={(e) => {
              const qty:number = convertStringToNumber(e.target.value);
              props.validate(qty,pieceQty,"pieceQty");
              setPieceQty(qty);
            }}
            label="Pc"
            percentage={100}
          />}
        </div>
        <div className="label-input-parent-edit">
          <FormControl className="batch-editor-dropdown">
            <Select
              className="dropdown"
              value={reason}
              size="small"
              sx={{ minWidth: "150px"}}
              onChange={(e) => setReason(e.target.value)}
              displayEmpty
              renderValue={(selected) =>
                selected ? (
                  <span className="dropdown-selected-item">{selected}</span>
                ) : (
                  <span className="dropdown-placeholder">Select a Reason</span>
                )
              }
            >
              {reasonArray.map((reason, index) => (
                <MenuItem key={index} value={reason}>
                  <div className="dropdown-menu-item">{reason}</div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>)
      :
      (<div className="delivery-label-input-reason-container-edit full-width">
        <div className="delivery-label-input-container-edit full-width">
          <div className="cs-pc-container-edit">
            {caseUnitLabel && <CustomCsPcInput
              value={caseQty}
              onChange={(e) => {
                  const qty:number = convertStringToNumber(e.target.value);
                  props.validate(qty,caseQty,"caseQty");
                  setCaseQty(qty);
                }
              }
              label="Cs"
              percentage={100}
            />}
            {otherUnitLabel && <CustomCsPcInput
              value={otherQty}
              onChange={(e) => {
                const qty:number = convertStringToNumber(e.target.value);
                props.validate(qty,otherQty,"otherQty");
                setOtherQty(qty);
              }}
              disabled={props.disabledUoms && props.disabledUoms.includes("otherQty")}
              label= {props.otherUnitName? props.otherUnitName: "Other"}
              percentage={100}
            />}
            {packUnitLabel && <CustomCsPcInput
              value={pieceQty}
              onChange={(e) => {
                const qty:number = convertStringToNumber(e.target.value);
                props.validate(qty,pieceQty,"pieceQty");
                setPieceQty(qty);
              }}
              label="Pc"
              percentage={100}
            />}
          </div>
          {props.actionElement}
        </div>
        <div className="delivery-label-reason-container-edit">
        <div className="delivery-sale-condition-toggle-container">
          <form>
            <div className="delivery-sale-condition-toggle-container">
              {Object.keys(reasonMap).map((key,index)=>{
                return <div key={index} className="delivery-sale-condition-toggle">
                  <label style={{ display: "flex", alignItems: "center", cursor: "pointer", width: "7rem", height: "1.5rem", fontSize: "13px" }}>
                    <input
                      type="radio"
                      className="batchListItem-radio-button"
                      name="delivery-reason-toggle"
                      value={key}
                      checked={saleCondition === key}
                      onChange={() => handleSaleConditionChange(key)}
                      style={{ marginRight: "8px" }}
                    />
                    <span>{key}</span>
                  </label>
                </div>
              })}
            </div>
          </form>
        </div>
          <div className={`delivery-label-input-reason-container-edit ${saleCondition ? "" : "disabled"}`}>
            <FormControl className="batch-editor-dropdown">
              <Select
                className="dropdown"
                value={reason}
                size="small"
                sx={{ minWidth: "150px"}}
                onChange={(e) => setReason(e.target.value)}
                displayEmpty
                renderValue={(selected) =>
                  selected ? (
                    <span className="dropdown-selected-item">{selected}</span>
                  ) : (
                    <span className="dropdown-placeholder">Select a Reason</span>
                  )
                }
              >
                {saleCondition && reasonMap[saleCondition]?.map((reason, index) => (
                  <MenuItem key={index} value={reason}>
                    <div className="dropdown-menu-item">{reason}</div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </div>)
  }
  
  type ValidateFunctionType = (qty: number, prevQty: number, key: "pieceQty" | "caseQty" | "otherQty") => void;

  const convertStringToNumber = (val:string, avoidExecption?:boolean)=>{
    if(val == ""){
      return 0;
    }
    if(isNaN(Number(val))){
      if(avoidExecption){
        return 0;
      }else{
        throw Error("invalid entry")
      }
    }
    return Number(val);
  }
  
  export default DeliveryInvoiceReasonSelection;